import {
  SoftwareUpdate,
  FactorySettings,
  UpdateType,
  FactorySettingType,
} from "models/Update";
import api from "./api";

export const getUpdateUrlTypeFromType = (type: UpdateType) =>
  type === "softwareUpdates" ? "updates" : "factory_settings";

type UpdateResponse = {
  data?: FactorySettings[];
  software?: SoftwareUpdate[];
};

const getUpdates = async (type: UpdateType) => {
  const response = await api.get<UpdateResponse>(
    `${getUpdateUrlTypeFromType(type)}`
  );

  if (type === "softwareUpdates") {
    return response.data.software;
  }

  return response.data.data;
};

const addSoftwareUpdate = async (
  type: UpdateType,
  file: File,
  typeId?: number
) => {
  const formData = new FormData();
  formData.append("update", file);
  formData.append("fileName", file.name);

  if (typeId) {
    formData.append("typeId", typeId.toString());
  }

  const response = await api.post(
    `${getUpdateUrlTypeFromType(type)}`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

const deleteSoftwareUpdate = async (key: string) => {
  const response = await api.delete("updates", {
    data: {
      key,
    },
  });

  return response.data;
};

const deleteFactorySetting = async (id: string) => {
  const response = await api.delete(`factory_settings/${id}`);

  return response.data;
};

const getFactorySettingTypes = async () => {
  const response = await api.get<FactorySettingType>("factory_settings_types");

  return response.data;
};

const addFactorySettingType = async (label: string) => {
  const response = await api.post("factory_settings_types", {
    label,
  });

  return response.data;
};

const deleteFactorySettingType = async (id: number) => {
  const response = await api.delete(`factory_settings_types/${id}`);

  return response.data;
};

export default {
  getUpdates,
  addSoftwareUpdate,
  deleteSoftwareUpdate,
  deleteFactorySetting,
  getFactorySettingTypes,
  addFactorySettingType,
  deleteFactorySettingType,
};
